import script from "./infoRoadmap.vue?vue&type=script&setup=true&lang=js"
export * from "./infoRoadmap.vue?vue&type=script&setup=true&lang=js"

import "./infoRoadmap.vue?vue&type=style&index=0&id=64b548cc&lang=scss&scoped=true"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64b548cc"]])

export default __exports__